
import { useState, useEffect } from 'react';

export default function ContactHero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <section className="relative min-h-[50vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/abbf528f02c734ce2ca9cb11ebcab16e.jpg"
          alt="Contact Dallas Health Insurance Experts"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6">
            Let's Find Your Perfect Coverage
          </h1>
          <p className="text-xl md:text-2xl text-white/95 mb-8 leading-relaxed">
            Reach out today for a free consultation with Dallas's trusted health insurance experts
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a
              href="tel:+12143060121"
              className="px-8 py-4 bg-secondary text-white rounded-lg font-semibold hover:bg-secondary/90 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-3 text-lg"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>(214) 306-0121</span>
            </a>
            <div className="flex items-center gap-3 text-white">
              <i className="ri-time-line text-2xl"></i>
              <div className="text-left">
                <div className="font-semibold">Mon-Fri: 8:00 AM - 6:00 PM</div>
                <div className="text-sm text-white/90">Saturday: 9:00 AM - 2:00 PM</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
